import { useMemo, useState } from 'react'
import { useTheme } from 'react-jss'

import { getDateRangeLabel, getMobileDateRangeLabel } from './helpers'

export default function useDateRange(datePeriod, isMobile) {
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false)

  const rangeColors = useMemo(() => [theme.brandPrimaryLight], [theme.brandPrimaryLight])

  const { startDate, endDate } = datePeriod

  const dateRangeLabel = useMemo(() => {
    if (!startDate || !endDate) {
      return ''
    }

    if (isMobile) {
      return getMobileDateRangeLabel(startDate, endDate)
    }

    return getDateRangeLabel(startDate, endDate)
  }, [startDate, endDate, isMobile])

  return useMemo(
    () => ({
      isOpen,
      setIsOpen,
      rangeColors,
      dateRangeLabel
    }),
    [isOpen, setIsOpen, rangeColors, dateRangeLabel]
  )
}
